// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeout-animation-center {
  position: fixed;
  left: 50%;
  top: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
  background-color: white;
  gap: 1rem;
  padding: 25px;
  box-shadow: 0px 0px 20px 1px var(--vodafone-grey);
  z-index: 2;
  border-radius: 5px;
}
.timeout-animation-clock {
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 30px;
  border: solid 5px black;
}
.timeout-animation-hours {
  position: absolute;
  width: 50px;
  height: 5px;
  top: 22.5px;
  animation: clock-spin 5s linear 0s infinite;
}
.timeout-animation-hours:before {
  content: "";
  height: 5px;
  width: 16px;
  position: absolute;
  right: 11px;
  background: black;
  border-radius: 5px;
}
.timeout-animation-minutes {
  position: absolute;
  width: 50px;
  height: 5px;
  top: 22.5px;
  animation: clock-spin 0.41s linear 0s infinite;
}
.timeout-animation-minutes:before {
  content: "";
  height: 5px;
  width: 22px;
  position: absolute;
  right: 5px;
  background: black;
  border-radius: 5px;
}

@keyframes clock-spin {
  0% {
    -webkit-transform: rotate(0deg);
    visibility: visible;
  }
  100% {
    -webkit-transform: rotate(360deg);
    visibility: hidden;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/loader/timeout-animation.scss"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,iDAAA;EACA,UAAA;EACA,kBAAA;AAAR;AAGI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AADR;AAII;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,2CAAA;AAFR;AAII;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAFR;AAII;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,8CAAA;AAFR;AAKI;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AAHR;;AAOA;EACC;IAAK,+BAAA;IAAiC,mBAAA;EAFrC;EAGD;IAAO,iCAAA;IAAmC,kBAAA;EACzC;AACF","sourcesContent":[".timeout-animation{\n    &-center {\n        position: fixed;\n        left: 50%;\n        top: 50%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        transform: translate(-50%,-50%);\n        background-color: white;\n        gap: 1rem;\n        padding: 25px;\n        box-shadow: 0px 0px 20px 1px var(--vodafone-grey);\n        z-index: 2;\n        border-radius: 5px;\n    }\n\n    &-clock {\n        position: relative;\n        width: 50px;\n        height: 50px;\n        border-radius: 30px;\n        border: solid 5px black;\n    }\n    \n    &-hours {\n        position: absolute;\n        width: 50px;\n        height: 5px;\n        top: 22.5px;\n        animation: clock-spin 5s linear 0s infinite;\n    }\n    &-hours:before {\n        content: \"\";\n        height: 5px;\n        width: 16px;\n        position: absolute;\n        right: 11px;\n        background: black;\n        border-radius: 5px;\n    }\n    &-minutes {\n        position: absolute;\n        width: 50px;\n        height: 5px;\n        top: 22.5px;\n        animation: clock-spin 0.41s linear 0s infinite;\n    }\n\n    &-minutes:before {\n        content: \"\";\n        height: 5px;\n        width: 22px;\n        position: absolute;\n        right: 5px;\n        background: black;\n        border-radius: 5px;\n    }\n}\n\n@keyframes clock-spin {\n\t0% { -webkit-transform: rotate(0deg); visibility: visible;}\n\t100% { -webkit-transform: rotate(360deg); visibility: hidden;}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
